function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 0h10a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm0 9h10a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm1.5-7a.5.5 0 000 1h7a.5.5 0 000-1h-7zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 6a.5.5 0 100 1h6a.5.5 0 100-1h-6z"
});

var SvgSegmentIcon = function SvgSegmentIcon(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13"
  }, props), _ref);
};

export default SvgSegmentIcon;